import { zSchema } from "../schema-validation";

/**
 * Returns a Zod object `{ event, data }`. Typed as `ZodTypeAny` in declarations so
 * `tsc --declaration` does not emit fragile mapped types over Zod 3.25 generics.
 */
export const getSSEBaseSchema = <T extends zSchema.ZodTypeAny>(
  dataSchema: T
): zSchema.ZodTypeAny =>
  zSchema.object({
    event: zSchema.string(),
    data: dataSchema,
  });
